import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { setCurrentClientID, thunkCreateSaaSAdmin } from '../../redux/actions';
import NoAdminPermissions from 'components/RestrictedRoute/NoAdminPermissions';
import Loader from 'components/Loader';
import { isSaaSAdmin, isSuperAdmin } from '@/redux/util';
import { FirstEventWalkthroughSkeleton } from 'components/FirstEventWalkthrough/FirstEventWalkthrough';

const AdminPermissionsCheck = ({
	admins,
	adminSSOProfile,
	permissive,
	children,
	createSaaSAdmin,
	setCurrentClientID,
}) => {
	const [isCreatingAdmin, setIsCreatingAdmin] = React.useState(false);
	const { email } = adminSSOProfile;
	const adminPermissions = admins[email];
	const hasNoAdminPermissions = adminPermissions && !Object.keys(adminPermissions).length;
	const hasContent =
		isSuperAdmin() ||
		(adminPermissions &&
			Object.keys(adminPermissions).length &&
			(adminPermissions.events.length ||
				adminPermissions.perms.length ||
				adminPermissions.clients.length));

	useEffect(() => {
		const createAdmin = async () => {
			if (hasNoAdminPermissions && adminSSOProfile?.email && !isCreatingAdmin) {
				setIsCreatingAdmin(true);
				try {
					await createSaaSAdmin(email);
					setCurrentClientID(1);
				} finally {
					setIsCreatingAdmin(false);
				}
			}
		};
		createAdmin();
	}, [
		hasNoAdminPermissions,
		adminSSOProfile,
		email,
		createSaaSAdmin,
		setCurrentClientID,
		isCreatingAdmin,
	]);

	if (isCreatingAdmin) return <FirstEventWalkthroughSkeleton />;

	if (!adminPermissions) return <Loader />;

	if (!hasContent && permissive && isSaaSAdmin()) {
		setCurrentClientID(1);
		return children;
	}

	if (hasContent || isSaaSAdmin()) {
		return children;
	}

	if (hasNoAdminPermissions) {
		return <NoAdminPermissions userEmail={email} />;
	}

	return <Loader />;
};

const mdp = dispatch => ({
	setCurrentClientID: clientID => dispatch(setCurrentClientID(clientID)),
	createSaaSAdmin: email => dispatch(thunkCreateSaaSAdmin(email)),
});

export default connect(null, mdp)(AdminPermissionsCheck);
